import { TextAvatar } from '@/shared/ui/components';
import { generateFullName } from '@/shared/lib';
import _ from 'lodash';
import { t } from 'ttag';
import type { SupportParticipantProps } from './supportParticipant.types';

/**
 * Participant list of the support request detail page. Maps detailData.participants to a TextAvatar plus the generateFullName display name for each user.
 *
 * @param detailData - Support request record carrying the participant list.
 * @returns The participant list element.
 */
const SupportParticipant = ({ detailData }: SupportParticipantProps) => {
  const { participants } = detailData || {};

  return (
    <div className="part-participant">
      <div className="title">{t`Participant`}</div>
      <div className="content">
        {_.map(participants, (user) => (
          <div key={user?.id} className="user">
            <TextAvatar data={user} />
            <div className="name">{generateFullName(user)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportParticipant;
